import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  updatePrintSettingsApiService,
  type PrintSettings,
  type UpdatePrintSettingsRequest,
} from "@/generated/fastapi";

export async function updatePrintSettings(
  accessToken: string | null | undefined,
  request: UpdatePrintSettingsRequest,
) : Promise<PrintSettings> {
  const response = await updatePrintSettingsApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Failed to update print settings");
  }

  return response.data as PrintSettings;
}
